// holidayActions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateHolidayPayload, UpdateHolidayPayload, DeleteHolidayPayload, FetchHolidayByIdPayload } from './holidayTypes';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';

// Create Holiday
export const createHoliday = createAsyncThunk(
    'holidays/createHoliday',
    async (data: CreateHolidayPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.post('/holiday', data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create holiday');
        }
    }
);

// Update Holiday
export const updateHoliday = createAsyncThunk(
    'holidays/updateHoliday',
    async ({ holidayId, data }: { holidayId: number; data: Partial<UpdateHolidayPayload> }, { rejectWithValue }) =>{
        try {
            const response = await employeeServiceApiInstance.put(`/holiday/${holidayId}`, data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update holiday');
        }
    }
);

// Delete Holiday
export const deleteHoliday = createAsyncThunk(
    'holidays/deleteHoliday',
    async ({ holidayId }: DeleteHolidayPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/holiday/${holidayId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete holiday');
        }
    }
);

// Fetch Holiday by ID
export const fetchHolidayById = createAsyncThunk(
    'holidays/fetchHolidayById',
    async ({ holidayId }: FetchHolidayByIdPayload, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/holiday/${holidayId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch holiday');
        }
    }
);

// Fetch All Holidays
export const fetchAllHolidays = createAsyncThunk(
    'holidays/fetchAllHolidays',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/holiday');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch holidays');
        }
    }
);
// Fetch All Holidays by Months
export const fetchAllHolidaysByMonth = createAsyncThunk(
    'holidays/fetchAllHolidaysByMonth',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/count-by-month/holiday');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch holidays by Months');
        }
    }
);

// Fetch Next Upcoming Holiday
export const fetchNextUpcomingHoliday = createAsyncThunk(
    'holidays/fetchNextUpcomingHoliday',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/holiday/upcoming/next');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch next upcoming holiday');
        }
    }
);

